<template>
  <div class="user-study-questions-container" id="usqc">
    <div
      v-for="(q, index) in combinedArray"
      :key="index"
      class="mb-7 mt-7 question-and-answer"
    >
      <div
        v-if="q.studyQuestionStatement"
        v-html="q.studyQuestionStatement"
        class="study-question-statement mb-7 pt-7"
      ></div>

      <!-- Old way -->
      <!-- <div v-html="q.studyQuestion" class="mb-3 font-weight-bold question" :class="print"></div> -->

      <!-- Add the number before the question -->
      <div class="mb-3 font-weight-bold question">
        <strong>{{ q.questionNumber }}. </strong>
        <span v-html="q.studyQuestion"></span>
      </div>

      <div v-if="status !== 'archived'">
        <v-textarea
          :id="'studyQuestion-' + index"
          v-model="q.studyQuestionAnswer"
          auto-grow
          variant="filled"
          :rows="areaSize(q.studyQuestionResponseLines)"
          @focus="activate(index)"
          @blur="onQuestionChange(q, index, section)"
          row-height="24px"
          placeholder=""
          hide-details="auto"
          color="green"
          class="mb-7"
          :class="{ active: active_el == index }"
          style="min-width: 100%"
        >
          <template #label>
            <v-icon>pencil</v-icon>
          </template>
        </v-textarea>
        <div class="snippet-autosave-header">
          <div
            class="snippet-autosave-status"
            :class="'snippet-autosave-status-' + index"
          >
            <div class="snippet-autosave-status_label">
              {{ $t('unitStudy.studyQuestions.status') }}
            </div>
            <div class="snippet-autosave-status_spinner">
              <span class="snippet-autosave-status_spinner-label"></span>
              <span class="snippet-autosave-status_spinner-loader"></span>
            </div>
          </div>
        </div>
      </div>
      <div v-else :class="[status, print]">
        <!-- <span style="position: relative; overflow: hidden; width: 100%;" :style="{ 'min-height': defaultHeight(q.studyQuestionResponseLines)}">
                    {{ q.studyQuestionAnswer }}
                    <span v-if="q.studyQuestionAnswer == undefined && print == 'pdf'">
                        <hr v-for="t in underlines" :key="t" :style="{ top: t + 'px' }" class="underlined">
                    </span>
                </span> -->
        <span
          style="position: relative; overflow: hidden; width: 100%"
          :style="{ 'min-height': defaultHeight(q.studyQuestionResponseLines) }"
        >
          {{ q.studyQuestionAnswer }}
          <span v-if="q.studyQuestionAnswer == undefined && print == 'pdf'">
            <hr
              v-for="t in numOfLines(q.studyQuestionResponseLines)"
              :key="t"
              class="underlines"
            />
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import db from '@/firebase/init'
  import debounce from 'lodash/debounce'

  export default {
    name: 'UserStudyQuestions',
    props: [
      'content',
      'section',
      'backdoor',
      'unitbackdoor',
      'status',
      'print',
      'unitID',
      'sectionID',
    ],
    data() {
      return {
        // studyquestions: [],
        studyQuestionStatement: '',
        studyQuestion: '',
        studyQuestionResponseLines: '',
        studyQuestionAnswer: '',
        studyQuestions: [],
        combinedArray: [],
        active_el: null,
        underlines: [
          21, 45, 69, 93, 117, 141, 165, 189, 213, 237, 261, 285, 309, 333, 357,
          381, 405, 429, 453, 477, 501, 525, 549, 573, 597, 621, 645, 669, 693,
          717, 741, 765, 789, 813, 837, 861, 885, 909, 933, 957, 981, 1005,
        ],
        saveTimeoutByKey: {},
      }
    },
    components: {},
    watch: {
      // backdoor: function(newVal, oldVal) { // watch it
      //     console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      // },
      unitbackdoor: {
        handler: function (search) {
          // console.log('2 ', search)
          if (search) this.init()
        },
        deep: true,
        immediate: true,
      },
    },
    updated: debounce(function () {
      this.$nextTick(() => {
        // console.log('test') // runs only once
        this.$emit('has-loaded', { loadingComplete: 'loading is complete' })
      })
    }, 500), // increase to ur needs
    methods: {
      activate: function (el) {
        this.active_el = el
      },
      areaSize(size) {
        if (size == 'short') return 2
        if (size == 'medium') return 4
        if (size == 'long') return 6

        return false
      },
      numOfLines(size) {
        if (size == 'short') return 3
        if (size == 'medium') return 8
        if (size == 'long') return 16

        return false
      },
      defaultHeight(size) {
        if (size == 'short') return '70px'
        if (size == 'medium') return '192px'
        if (size == 'long') return '386px'

        return false
      },
      setSaveStatus(key, status) {
        const statusIndicator = document.querySelectorAll(
          '.snippet-autosave-status-' + key
        )
        statusIndicator.forEach((el) => {
          el.classList.remove('busy', 'error')
          if (status === 'busy') el.classList.add('busy')
          if (status === 'error') el.classList.add('error')
        })
      },
      persistQuestionAnswer({
        courseID,
        sectionID,
        unitID,
        section,
        studyQuestionID,
        answer,
      }) {
        let coursecontentRef = db.collection('coursecontent')
        coursecontentRef = coursecontentRef.where('courseID', '==', courseID)
        coursecontentRef = coursecontentRef.where('sectionID', '==', sectionID)
        coursecontentRef = coursecontentRef.where('unitID', '==', unitID)
        coursecontentRef = coursecontentRef.where('section', '==', section)
        coursecontentRef = coursecontentRef.where(
          'studyQuestionID',
          '==',
          studyQuestionID
        )

        return coursecontentRef.get().then(async (snapshot) => {
          if (!snapshot.empty) {
            const writes = []
            snapshot.forEach((doc) => {
              if (answer !== null) {
                writes.push(
                  doc.ref.update({
                    studyQuestionAnswer: answer,
                  })
                )
              } else {
                writes.push(doc.ref.delete())
              }
            })
            await Promise.all(writes)
            return
          }

          if (answer !== null) {
            await db.collection('coursecontent').add({
              courseID,
              sectionID,
              unitID,
              section,
              studyQuestionID,
              studyQuestionAnswer: answer,
            })
          }
        })
      },
      // eslint-disable-next-line
      onQuestionChange(item, key, section) {
        this.setSaveStatus(key, 'busy')

        // Debounce per question index so quick edits in one field don't cancel others.
        if (this.saveTimeoutByKey[key]) clearTimeout(this.saveTimeoutByKey[key])

        this.saveTimeoutByKey[key] = setTimeout(async () => {
          try {
            const courseID = this.$route.params.courseID
            const sectionID = this.$route.params.sectionID
            const unitID = this.$route.params.id ? this.$route.params.id : this.unitID
            const rawAnswer =
              typeof item.studyQuestionAnswer === 'string'
                ? item.studyQuestionAnswer
                : ''
            const answer = rawAnswer.trim() === '' ? null : rawAnswer

            if (!courseID || !sectionID || !unitID) {
              throw new Error('Missing route IDs for study question save.')
            }

            await this.persistQuestionAnswer({
              courseID,
              sectionID,
              unitID,
              section,
              studyQuestionID: key,
              answer,
            })

            this.active_el = null
            await this.init()
            this.setSaveStatus(key, 'ready')
          } catch (error) {
            this.setSaveStatus(key, 'error')
            console.log('Error saving study question:', error)
          }
        }, 1000)
      },
      init() {
        this.studyQuestions = []

        let courseID = this.$route.params.courseID
        let sectionID = this.sectionID || this.$route.params.sectionID
        let unitID = this.$route.params.id ? this.$route.params.id : this.unitID

        var coursecontentRef = db.collection('coursecontent')
        coursecontentRef = coursecontentRef.where('courseID', '==', courseID)
        coursecontentRef = coursecontentRef.where('sectionID', '==', sectionID)
        coursecontentRef = coursecontentRef.where('unitID', '==', unitID)
        coursecontentRef = coursecontentRef.where('section', '==', this.section)
        coursecontentRef
          .get()
          .then((snapshot) => {
            if (!snapshot.empty) {
              snapshot.forEach((doc) => {
                let sq = doc.data()
                sq.id = doc.id
                if (sq.studyQuestionAnswer) {
                  // build an array of answers based off the section
                  this.studyQuestions.push(sq)
                }
              })
            }
          })
          .then(() => {
            for (let i = 0; i < this.studyQuestions.length; i++) {
              let ii = this.studyQuestions[i].studyQuestionID
              this.content[ii].studyQuestionID =
                this.studyQuestions[i].studyQuestionID
              this.content[ii].studyQuestionAnswer =
                this.studyQuestions[i].studyQuestionAnswer
            }

            // we have to use a new array to make the component reative
            this.combinedArray = this.content

            // Emit event to the parent indicating questions have loaded
            this.$emit('questionsLoaded', this.combinedArray)
          })
      },
    },
    created() {
      // this.init()
    },
  }
</script>

<style scoped>
  .user-study-questions-container :deep(label svg) {
    opacity: 0.25;
  }
  .v-input:not(.v-input--is-focused) :deep(.v-input__slot fieldset) {
    border-color: transparent;
  }
  .snippet-autosave-status {
    display: none;
  }
  /* .v-input--is-focused + .snippet-autosave-header .snippet-autosave-status {
    display: flex;
} */
  .active + .snippet-autosave-header .snippet-autosave-status {
    display: flex;
  }
  .snippet-autosave-status.error :deep(.snippet-autosave-status_spinner-label)::after {
    content: 'Save failed';
    color: #d32f2f;
  }
  .archived {
    background: rgba(0, 0, 0, 0.06);
    padding: 12px;
    border-radius: 4px;
    min-height: 56px;
    align-items: center;
    display: flex;
  }
  .question.pdf {
    padding-top: 12px;
    margin-bottom: 0px !important;
  }
  .archived.pdf {
    background: transparent;
    font-style: italic;
  }
  .study-question-statement {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .question-and-answer {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .underlined {
    width: 100%;
    position: absolute;
    border: none;
    border-top: 1px dotted rgba(0, 0, 0, 0.87);
  }
  .underlines {
    position: relative;
    border: none;
    border-top: 1px dotted rgba(0, 0, 0, 0.87);
    height: 30px;
  }
  .underlines:first-of-type {
    margin-top: 20px;
  }
  @media print {
    .underlined {
      display: none !important;
    }
  }
</style>
